import { Pipe, PipeTransform } from '@angular/core';
import { itmMenu } from 'src/app/models/auth-data.model';

@Pipe({
  name: 'iconos'
})
export class IconosPipe implements PipeTransform {

  transform(strTitle: string, lstModulos: itmMenu[]) {
    let strIcono = 'menu';
    if (lstModulos && lstModulos.length > 0) {
      const lstResModulos: itmMenu = lstModulos.find(
        item => item.title === strTitle
      );
      if (lstResModulos && lstResModulos.strIcono && lstResModulos.strIcono.trim() !== '') {
        strIcono = lstResModulos.strIcono.toLowerCase().trim();
      }
    }
    return strIcono;
  }

}
